import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import imageByIndex from "./imageByIndex";
import { DotButton, PrevButton, NextButton } from "./DotsAndButtons";
import "./subscribers-meet-slider.m.css";

const Carousel = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay()]);
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [
    emblaApi,
  ]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [
    emblaApi,
  ]);
  const scrollTo = useCallback(
    (index) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, setScrollSnaps, onSelect]);

  return (
    <>
      <div styleName="embla">
        <h2> Newslaundry subscriber meetups</h2>
        <div
          style={{
            margin: "5px auto",
            height: "3px",
            backgroundColor: "var(--primary-color)",
            maxWidth: "100px",
            borderRadius: "50px",
          }}
        ></div>

        <p>
        <i>Newslaundry</i> has a tightly knit community of engaged subscribers across
          the world. Subscribe now to be a part of an engaged community that
          believes in the ethos of free and independent press and get a chance
          to meet like minded people.
        </p>
        <br />
        <div styleName="embla__viewport" ref={emblaRef}>
          <div styleName="embla__container">
            {slides.map((index) => (
              <div styleName="embla__slide" key={index}>
                <div styleName="embla__slide__text">
                  <span>{imageByIndex(index).text}</span>
                </div>
                <img
                  styleName="embla__slide__img"
                  src={imageByIndex(index).src}
                  alt={imageByIndex(index).text}
                />
              </div>
            ))}
          </div>
        </div>
        {/* <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
                <NextButton onClick={scrollNext} enabled={nextBtnEnabled} /> */}
      </div>
      <div
        className="embla__dots"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          width: "70%",
          margin: "auto",
        }}
      >
        {scrollSnaps.map((_, index) => (
          <DotButton
            key={index}
            selected={index === selectedIndex}
            onClick={() => scrollTo(index)}
          />
        ))}
      </div>
    </>
  );
};

export default Carousel;
